import React, { useEffect, useState } from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";

const InvoiceDashboard = () => {
    const [invoices, setInvoices] = useState([]);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const url = process.env.REACT_APP_LINK;
    const token = decryptToken("accessToken") || ""

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const res = await fetch(`${url}/newinvoice/all/${isLoggedIn.main_id}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const data = await res.json();
                if (Array.isArray(data)) setInvoices(data);
            } catch (err) {
                console.error("Failed to fetch invoices:", err);
            }
        };

        fetchInvoices();
    }, []);

    const formatINR = (amt) =>
        `₹ ${Number(amt).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

    const validInvoices = invoices.filter((inv) => inv.dpstatus !== "Draft");

    const totalAmount = validInvoices.reduce(
        (sum, inv) => sum + (parseFloat(inv.grand_total) || 0),
        0
    );

    const totalPaid = validInvoices.reduce((sum, inv) => {
        const grand = parseFloat(inv.grand_total) || 0;
        const pending = parseFloat(inv.pending) || 0;
        return sum + (grand - pending);
    }, 0);

    const totalDue = totalAmount - totalPaid;
    const paidPercent = totalAmount > 0 ? (totalPaid / totalAmount) * 100 : 0;
    const duePercent = 100 - paidPercent;

    return (
        <div className="my-12 rounded-lg shadow-md p-4">
            <h2 className="text-[18px] font-semibold text-gray-800 mb-2">Invoice Summary</h2>

            <div>
                {/* Total Amount */}
                <div className="mb-4">
                    <p className="text-sm text-gray-500">Total Amount</p>
                    <h3 className="text-2xl font-bold text-blue-600">
                        {formatINR(totalAmount)}
                    </h3>
                </div>

                {/* Progress Bar */}
                <div className="w-full h-4 rounded overflow-hidden flex mb-4 bg-gray-200">
                    <div
                        className="bg-green-500 h-full transition-all duration-700"
                        style={{ width: `${paidPercent}%` }}
                        title={`Paid: ${formatINR(totalPaid)}`}
                    ></div>
                    <div
                        className="bg-red-500 h-full transition-all duration-700"
                        style={{ width: `${duePercent}%` }}
                        title={`Due: ${formatINR(totalDue)}`}
                    ></div>
                </div>

                {/* Paid and Due Breakdown */}
                <div className="flex justify-between items-center">
                    <div>
                        <p className="text-sm text-gray-500">Paid Amount</p>
                        <h3 className="text-lg font-semibold text-green-600">
                            {formatINR(totalPaid)}
                        </h3>
                    </div>
                    <div className="text-right">
                        <p className="text-sm text-gray-500">Due Amount</p>
                        <h3 className="text-lg font-semibold text-red-500">
                            {formatINR(totalDue)}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceDashboard;
